import 'fetch-polyfill';

/**
 * Función helper para obtener desde el site el json de locales
 * para el lenguaje indicado.
 * @param {*} locale
 * @param {*} clientPath
 */
export const fetchPhrases = (locale, clientPath) => {
    const fileUrl = clientPath + '/' + locale + '.json';

    return fetch(fileUrl)
    .then((response) => {

      if (response.status >= 400) {
        throw new Error('Bad response from server');
      }

      return response.json();
    });
};
